import axios from "axios";

const API_URL = process.env.REACT_APP_MARACANA;

// export function getLogged(token) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `logged`, { headers: {
//       Authorization: 'Bearer ' + token
//     }}).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getSports() {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `sports`).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

export function getBranches(data) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches`, {
      params: data,
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

export function getBranchBySlug(slug) {
  return new Promise((resolve, reject) => {
    axios.get(API_URL + `branches/info`, {
      params: { slug: slug },
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}

// export function getCampaigns(data) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `campaigns`, {
//       params: data,
//     }).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function postBranch(data) {
//   return new Promise((resolve, reject) => {
//     axios.post(API_URL + `branches`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getDisputes(data) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `disputes`, {
//       params: data,
//     }).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getDispute(group, dispute) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `groups/${group}/dispute`, { params: { dispute: dispute }}).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getUserDisputes() {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `user/disputes`).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function cancelDispute(group, dispute) {
//   return new Promise((resolve, reject) => {
//     axios.delete(API_URL + `groups/${group}/dispute`, {params: {dispute: dispute}}).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function postParticipant(group, data = []) {
//   return new Promise((resolve, reject) => {
//     axios.post(API_URL + `groups/${group}/participants`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function deleteParticipant(group, client, data = []) {
//   return new Promise((resolve, reject) => {
//     axios.delete(API_URL + `groups/${group}/participant/${client}`, {data: data}).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function joinGroup(group, data) {
//   return new Promise((resolve, reject) => {
//     axios.post(API_URL + `groups/${group}/join`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function leaveGroup(group, data = []) {
//   return new Promise((resolve, reject) => {
//     axios.delete(API_URL + `groups/${group}/leave`, { data: data }).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function deleteGroup(group) {
//   return new Promise((resolve, reject) => {
//     axios.delete(API_URL + `groups/${group}`).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function postGroup(data) {
//   return new Promise((resolve, reject) => {
//     axios.post(API_URL + `groups`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function updateGroup(group, data) {
//   return new Promise((resolve, reject) => {
//     axios.put(API_URL + `groups/${group}`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getGroup(group) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `groups/${group}`).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getGroups(data) {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `groups`, {
//       params: {
//         lat: data.lat,
//         long: data.long,
//         distance: data.distance,
//         sport: data.sport,
//       },
//     }).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function getUserGroups() {
//   return new Promise((resolve, reject) => {
//     axios.get(API_URL + `user/groups`).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

// export function updateProfile(data) {
//   return new Promise((resolve, reject) => {
//     axios.patch(API_URL + `me`, data).then(response => {
//       resolve(response.data)
//     }).catch(error => {
//       reject(error)
//     });
//   });
// }

export function deleteAccount(data) {
  return new Promise((resolve, reject) => {
    axios.delete(API_URL + `account`, { data: data }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    });
  });
}
